import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { marketingCmsSiteHistoryPath } from '@/views/marketing/marketing-routes';

import { useCmsPermissions } from './cms-permissions';
import { CmsShell } from './cms-ui';
import { CmsPendingReviews } from './CmsPendingReviews';
import { CmsReviewScreen } from './CmsReviewScreen';
import { CmsSitesEntry } from './CmsSitesEntry';
import { CmsVersionHistory } from './CmsVersionHistory';
import { CmsVisualEditor } from './CmsVisualEditor';
import { CreateCmsMicrosite } from './CreateCmsMicrosite';

const CmsMicrositeEntry = () => {
    const { cmsMicrositeGUID = '' } = useParams();
    const permissions = useCmsPermissions();

    if (permissions.isLoading) {
        return <div className="text-muted-foreground p-8 text-sm">Loading CMS site...</div>;
    }

    if (!permissions.canAdmin) {
        return <Navigate to={marketingCmsSiteHistoryPath(cmsMicrositeGUID)} replace />;
    }

    return <CmsVisualEditor />;
};

export const CmsRoutes = () => (
    <CmsShell>
        <Routes>
            <Route path="/" element={<Navigate to="sites" replace />} />
            <Route path="sites" element={<CmsSitesEntry />} />
            <Route path="sites/new" element={<CreateCmsMicrosite />} />
            <Route path="reviews" element={<CmsPendingReviews />} />
            <Route path="reviews/:cmsMicrositeGUID/:cmsContentVersionGUID" element={<CmsReviewScreen />} />
            <Route path="sites/:cmsMicrositeGUID" element={<CmsMicrositeEntry />} />
            <Route path="sites/:cmsMicrositeGUID/builder" element={<CmsVisualEditor />} />
            <Route path="sites/:cmsMicrositeGUID/history" element={<CmsVersionHistory />} />
            <Route path="*" element={<Navigate to="sites" replace />} />
        </Routes>
    </CmsShell>
);
